import cn from 'classnames';
import styles from './Timer.module.scss';
import { useEffect, useRef, useState } from "react";

const TIMER_KEY = "timer_seconds";
const DEFAULT_TIME = 15 * 60;
const MIN_TIME = 5 * 60;

function format(num) {
  return String(num).padStart(2, "0");
}
export const Timer = ({content})=>{
  const [scrolled, setScrolled] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(() => {
    const saved = Number(localStorage.getItem(TIMER_KEY));
    if (!isNaN(saved) && saved > 0) return saved;
    return DEFAULT_TIME;
  });
  const intervalRef = useRef();

  // скроллинг
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Тик таймера
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev > 0) return prev - 1;
        return 0;
      });
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, []);

  // Логика сохранения и восстановления
  useEffect(() => {
    // Если осталось меньше 5 минут — сбрасываем на 5 минут при обновлении страницы
    if (secondsLeft <= MIN_TIME && secondsLeft > 0) {
      localStorage.setItem(TIMER_KEY, MIN_TIME);
    } else if (secondsLeft === 0) {
      localStorage.setItem(TIMER_KEY, MIN_TIME); // Сбросим на 5 минут для следующей загрузки
    } else {
      localStorage.setItem(TIMER_KEY, secondsLeft);
    }
  }, [secondsLeft]);

  // Если при загрузке уже меньше 5 минут — сбрасываем
  useEffect(() => {
    const saved = Number(localStorage.getItem(TIMER_KEY));
    if (!isNaN(saved) && saved <= MIN_TIME && saved > 0) {
      setSecondsLeft(MIN_TIME);
    }
    // Если 0 — не сбрасываем сразу, только при перезагрузке (см. выше)
  }, []);

  // Вычисляем минуты и секунды для отображения
  const min = Math.floor(secondsLeft / 60);
  const sec = secondsLeft % 60;
  const {mainText,shortText,button,minute,second} =content;

  function handleClick() {
    const target = document.getElementById('payment-method');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }
  return (
    <>
    {
      <>
      <div className={styles.wrapper}>
        <div className={styles.text}>{mainText}</div>
        <div className={styles.row}>
          <div className={styles.timer}>
            <div className={styles.box}>
              <span className={styles.counter}>{format(min)}</span>
              <span className={styles.footerBox}>{minute}</span>
            </div>
            <div className={styles.box}>
              <span className={styles.counter}>:</span>
            </div>
            <div className={styles.box}>
              <span className={styles.counter}>{format(sec)}</span>
              <span className={styles.footerBox}>{second}</span>
            </div>
          </div>
          <div className={styles.button} onClick={()=>handleClick()}>{button}</div>
        </div>
      </div>
      <div className={cn(styles.wrapperLittle,
        scrolled && styles.scrolled,
      )}>
        <span>{shortText} </span>
        <span>{format(min)}:{format(sec)}</span>
      </div>
      </>
    }
    
    </>
  )
}